module.exports = __webpack_public_path__ + "bb9a82a87544ffdfda5391f3d7dd1047.svg";